import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import MCQLayout from "../components/MCQLayout";
import {
  setMCQContext,
  getMCQContext
} from "../utils/mcqContext";

function McqTeacher() {

  const { id: teacherId } =
    useParams();

  const location =
    useLocation();

  const navigate =
    useNavigate();

  const queryParams =
    new URLSearchParams(
      location.search
    );

  const urlModuleId =
    queryParams.get(
      "module_id"
    );

  const context =
    getMCQContext();

  const moduleId =
    urlModuleId ||
    context?.moduleId;

  const [questions, setQuestions] =
    useState([]);

  const [answers, setAnswers] =
    useState({});

  const [submitted, setSubmitted] =
    useState(false);

  const [score, setScore] =
    useState(null);

  const [subjectName, setSubjectName] =
    useState("");

  const [teacherName, setTeacherName] =
    useState("");

  const EXAM_TIME =
    5 * 60;

  const [timeLeft, setTimeLeft] =
    useState(EXAM_TIME);

  const timerRef =
    useRef(null);

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */
  useEffect(() => {
    const navbar =
      document.querySelector(
        ".navbar"
      );

    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity =
          "1";
      } else {
        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";
        navbar.style.opacity =
          "0";
      }
    };

    if (navbar) {
      navbar.style.position =
        "fixed";
      navbar.style.top =
        "15px";
      navbar.style.left =
        "50%";
      navbar.style.width =
        "90%";
      navbar.style.maxWidth =
        "1100px";
      navbar.style.transform =
        "translateX(-50%)";
      navbar.style.zIndex =
        "9999";
      navbar.style.transition =
        "all 0.35s ease";
    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {
        navbar.style.transform =
          "translateX(-50%) translateY(0)";
        navbar.style.opacity =
          "1";
      }
    };
  }, []);

  /* ================= FETCH ================= */
  useEffect(() => {

    if (
      !teacherId ||
      !moduleId
    ) {
      console.error(
        "❌ Missing moduleId or teacherId"
      );

      navigate("/mcq");
      return;
    }

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/al-sinhala-free-mcq?teacher_id=${teacherId}&module_id=${moduleId}`
    )
      .then(res =>
        res.json()
      )
      .then(data => {

        const formatted =
          (data.mcq_data || []).map(q => ({
            id: q.id,
            question:
              q.question,
            correct_answer:
              q.correct_answer,
            options: [
              q.option_a,
              q.option_b,
              q.option_c,
              q.option_d,
            ]
          }));

        setQuestions(
          formatted
        );

        setSubjectName(
          data.subject_name
        );

        setTeacherName(
          data.teacher_name
        );

        setMCQContext({
          subjectId:
            context?.subjectId,
          subjectName:
            data.subject_name,
          teacherId,
          teacherName:
            data.teacher_name,
          moduleId,
          type:
            context?.type ||
            "free"
        });

      })
      .catch(err => {
        console.error(
          "MCQ load error:",
          err
        );
      });

  }, [
    teacherId,
    moduleId,
    navigate
  ]);

  /* ================= TIMER ================= */
  useEffect(() => {

    if (submitted)
      return;

    timerRef.current =
      setInterval(() => {

        setTimeLeft(t => {

          if (t <= 1) {
            clearInterval(
              timerRef.current
            );

            handleSubmit();

            return 0;
          }

          return t - 1;

        });

      }, 1000);

    return () =>
      clearInterval(
        timerRef.current
      );

  }, [submitted]);

  /* ================= FORMAT TIME ================= */
  const formatTime = () => {
    const m =
      Math.floor(
        timeLeft / 60
      );

    const s =
      timeLeft % 60;

    return `${m
      .toString()
      .padStart(
        2,
        "0"
      )} : ${s
      .toString()
      .padStart(
        2,
        "0"
      )}`;
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = () => {

    if (
      timerRef.current
    ) {
      clearInterval(
        timerRef.current
      );
    }

    let total = 0;

    questions.forEach(q => {
      if (
        answers[q.id] ===
        q.correct_answer
      ) {
        total++;
      }
    });

    setScore(total);
    setSubmitted(true);
  };

  /* ================= CONTINUE ================= */
  const handleContinue = () => {

    const user =
      JSON.parse(
        localStorage.getItem(
          "user"
        )
      );

    if (!user) {
      navigate("/auth");
      return;
    }

    const ctx =
      JSON.parse(
        localStorage.getItem(
          "mcqContext"
        )
      );

    if (
      ctx?.type ===
      "paid"
    ) {
      navigate(
        "/dashboard"
      );
    } else {
      navigate(
        "/profile"
      );
    }
  };

  return (
    <MCQLayout
      title={`Free MCQ (${questions.length})`}
      subject={subjectName}
      teacher={teacherName}
      questions={questions}
      timeLeft={formatTime()}
      answers={answers}
      submitted={submitted}
      score={score}

      onAnswer={(
        id,
        opt
      ) =>
        setAnswers(
          prev => ({
            ...prev,
            [id]: opt
          })
        )
      }

      onSubmit={
        handleSubmit
      }

      onContinue={
        handleContinue
      }
    />
  );
}

export default McqTeacher;


/* ================= STYLES ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  backdropFilter: "blur(6px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000
};

const premiumCard = {
  background: "#fff",
  padding: "40px",
  borderRadius: "20px",
  width: "380px",
  textAlign: "center",
  border: "2px dashed #ef4444",
  boxShadow: "0 25px 70px rgba(0,0,0,0.35)"
};

const unlockBtn = {
  marginTop: "25px",
  padding: "14px",
  background: "#ef4444",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  width: "100%"
};